module.exports = __webpack_public_path__ + "static/media/sprite-mono.cbb4fa02.svg";